import { render } from "./Cs2AdminSetResult.vue?vue&type=template&id=1f60b176&scoped=true"
import script from "./Cs2AdminSetResult.vue?vue&type=script&lang=js"
export * from "./Cs2AdminSetResult.vue?vue&type=script&lang=js"

import "./Cs2AdminSetResult.vue?vue&type=style&index=0&id=1f60b176&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f60b176"]])

export default __exports__